<template>
  <vs-button
    class="invoke-button cursor-pointer"
    :type="type"
    :color="color"
    :style="buttonStyle"
    @mouseover="isHover = true"
    @mouseleave="isHover = false"
    @click="onClick"
    :disabled="disabled"
  >
    <span class="invoke-text aisea-text-16-400-pure-white whitespace-no-wrap">{{
      text
    }}</span>
  </vs-button>
</template>

<script>
import { ColorMixin } from "@/mixins";
const { AISEA_COLOR } = ColorMixin.data();

const EVENTS = {
  CLICK: "click",
};

export default {
  name: "InvokeButton",

  props: {
    text: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: AISEA_COLOR.BLUE,
    },
    type: {
      type: String,
      default: "filled",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHover: false,
    };
  },

  computed: {
    buttonStyle() {
      return {
        "box-shadow": "none",
        background: "none",
        backgroundColor: this.isHover ? "#0277bd" : this.color,
      };
    },
  },

  methods: {
    onClick() {
      this.$emit(EVENTS.CLICK);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.invoke-button {
  &.vs-button {
    width: 282px;
    height: 60px;
    padding: 16px 136px;

    ::v-deep .vs-button-backgroundx.vs-button--background {
      display: none; // ボタンクリックした時に、背景色が変わるのを防ぐ
    }
  }
}
</style>
